// The run-view composer sits on the gallery's footer band with a quiet
// ground, so the input reads as the frame's edge rather than a card
// floating in the transcript.
import { type ReactNode } from 'react';

export function ComposerFooter({
    children,
}: Readonly<{ readonly children: ReactNode }>): ReactNode {
    return (
        <div className="bg-background w-full min-w-0 overflow-visible pb-3">
            {children}
        </div>
    );
}
